export interface ScrollableParent {
  element: HTMLElement;
  unscrollableTop: number;
  unscrollableBottom: number;
}

export function getScrollableParent(element: any): ScrollableParent | null {
  let unscrollableTop = 0;
  let unscrollableBottom = 0;

  while (element && !isScrollable(element)) {
    element = element.parentNode;
    if (element === document) {
      // we found nothing scollable, we give up
      return null;
    }
    if (!isScrollable(element)) {
      unscrollableTop += getSiblingStickyAreaHeight(element, true);
      unscrollableBottom += getSiblingStickyAreaHeight(element, false);
    }
  }

  return {element, unscrollableTop, unscrollableBottom};
}

export function scrollToTop(nativeElement: HTMLElement | null | undefined): void {
  if (!nativeElement) {
    return;
  }
  const scrollAbleElement = getScrollableParent(nativeElement);

  if (scrollAbleElement) {
    scrollAbleElement.element.scrollTop = 0;
  }
}

export function getSiblingStickyAreaHeight(element: Element, isHeader: boolean): number {
  let stickyArea = 0;
  let _element: Element | null = isHeader ? element.previousElementSibling : element.nextElementSibling;

  while (_element) {
    const computedStyle = window.getComputedStyle(_element);

    const isSticky = computedStyle.position === 'sticky' || computedStyle.position === 'fixed';
    if (computedStyle.display !== 'none' && isSticky) {
      stickyArea += _element.getBoundingClientRect().height;
    }

    _element = isHeader ? _element.previousElementSibling : _element.nextElementSibling;
  }

  return stickyArea;
}

function isScrollable(el: Element): boolean {
  const overflowY = window.getComputedStyle(el).overflowY;

  return overflowY !== 'visible' && overflowY !== 'hidden';
}
